import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=152bf5d7&scoped=true&"
import script from "./Reservation.vue?vue&type=script&lang=js&"
export * from "./Reservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bf5d7",
  null
  
)

export default component.exports